<template>
  <sliding-up-layout :show-menu="!!items.length" @open="items = $event ? items : []" close-on-select>
    <div class="menu-content p-3">
      <div class="menu-list">
        <flex-layout
          v-for="(item, i) in items" :key="i"
          class="menu-item"
          justify="center"
          align="align"
          @click="onclick(item)"
          @keyup.enter="onclick(item)"
        >
          <flex-layout class="col-12" justify="center" align="center">
            <base-text color="primary" class="pt-1" justify="center">{{ item.text }}</base-text>
          </flex-layout>
        </flex-layout>
      </div>
    </div>
  </sliding-up-layout>
</template>

<script setup lang="ts" generic="T extends { text: string }">
import {defineModel} from 'vue'
import BaseText from '@/components/Texts/BaseText.vue';
import FlexLayout from '@/components/Layouts/FlexLayout.vue';
import SlidingUpLayout from '@/components/Layouts/SlidingUpLayout.vue';

const items = defineModel<T[]>({default: []});

const emits = defineEmits(['click']);

function onclick(item: T) {
  emits('click', item)
}
</script>

<style scoped>

.menu-item {
  height: 55px;
  width: 100%;
  cursor: pointer;
}

.menu-item:hover {
  background: var(--grayLight);
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--placeholder);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: red;
}

.menu-content {
  background-color: var(--inputBackground);
  contain: content;
  border: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.menu-list {
  max-height: 300px;
  overflow-y: auto;
}

.menu-item {
  min-height: 58px;
  cursor: pointer;
  transition: 300ms;
}

.menu-item:hover {
  background-color: var(--gray);
}
</style>
